import { main, registerComponents } from '@eastsideco/salvo-ts';

// Register components with SALVO-TS
registerComponents(require.context('./components/', true));

// Initialize theme
export const theme = main({
    enableLegacySalvoLiteComponentSupport: true,
});
